export enum NewPeriodSelectorConfigurationType {
    OldPeriodSelector = 0,
    CropCycleDetails = 1,
    CompareCropCycle = 2,
    Grower = 3,
    Empty = 4
}